// Onboarding Step 1 progress (ENTRAID-247): has this user started the external
// admin-consent step (opened the Microsoft consent page or copied its link)?
// The "Consent granted, continue to Step 2" button stays disabled until then,
// so nobody skips past a step they never began. Kept per customer in
// sessionStorage only: it survives a reload of this onboarding session and
// dies with the tab. It is a UX gate, never an authorization input; the
// deploy step is still what proves consent is in place.

const PREFIX = 'onguard.consentStarted.';

export function markConsentStarted(customerId) {
  if (!customerId) return;
  try {
    sessionStorage.setItem(PREFIX + customerId, '1');
  } catch {
    /* best-effort: without storage the gate simply resets on reload */
  }
}

export function hasStartedConsent(customerId) {
  if (!customerId) return false;
  try {
    return sessionStorage.getItem(PREFIX + customerId) === '1';
  } catch {
    return false;
  }
}

// One generated link per onboarding session (SEC-001 / SEC-002): each link
// carries a single-use server-side request (the admin-consent sign-in state,
// or the trust stack registration nonce), so a reload must reuse the link it
// already has instead of minting another and pushing out the one that was
// sent to an administrator. sessionStorage only; a UX cache, never an
// authorization input.
// The version is part of the key: bump it whenever the link format changes,
// so a tab opened before a deploy never reuses a link the new release no
// longer issues (ENTRAID-261: a cached v1-style admin_consent prompt link
// kept failing with AADSTS901001 after the fix was deployed).
export const LINK_CACHE_VERSION = 'v2';
const LINK_PREFIX = `onguard.link.${LINK_CACHE_VERSION}.`;
const LINK_SAFETY_MS = 60_000;

export function saveSessionLink(kind, customerId, url, expiresInSeconds, now = Date.now()) {
  if (!customerId || !url || !Number.isFinite(expiresInSeconds)) return;
  try {
    sessionStorage.setItem(`${LINK_PREFIX}${kind}.${customerId}`, JSON.stringify({ url, expiresAt: now + expiresInSeconds * 1000 }));
  } catch {
    /* best-effort */
  }
}

export function loadSessionLink(kind, customerId, now = Date.now()) {
  if (!customerId) return null;
  try {
    const saved = JSON.parse(sessionStorage.getItem(`${LINK_PREFIX}${kind}.${customerId}`) || 'null');
    if (saved && typeof saved.url === 'string' && saved.expiresAt - LINK_SAFETY_MS > now) return saved.url;
  } catch {
    /* ignore */
  }
  return null;
}

export function forgetSessionLink(kind, customerId) {
  try {
    sessionStorage.removeItem(`${LINK_PREFIX}${kind}.${customerId}`);
  } catch {
    /* ignore */
  }
}
